export const functionCalls = [
    {
        "type": "function",
        "function": {
            "name": "thinking",
            "description": "explain your reasoning and decision process.",
            "parameters": {
                "type": "object",
                "properties": {
                    "text": {
                        "type": "string",
                        "description": "your thinking."
                    }
                }
            }
        }
    },

    {
        "type": "function",
        "function": {
            "name": "navigateToPage",
            "description": `navigate the router to the selected page.
                Use this mapping:
                - "home", "main" → "/home"
                - "scenes", "scene list" → "/editor/list"
                - "scene" → "/editor/scene/"
                - "resources", "resource list" → "/resources/list"
                - "paint", "paint list" → "/paint/list"
                - "catalog", "catalog list", "catalog editor" → "/catalog/list"
                - "scheduler", "scheduler editor" → "/scheduler/editor"
                - "events", "event list" → "/events/list"
                - "stations", "station list", "players", "player list" → "/stations"
                - "fasterq" → "/fasterq/list"
                - "statistics", "dashboard" → "/statistics"
                - "download" → "/download"
                - "products",  → "/shopping/products"
                - "cart", "shopping", "shopping list" → "/shopping/list"
                - "checkout", "shopping checkout" → "/shopping/checkout"
                - "account", "payment", "payment info", "orders", "security" → "/orders"
                - "settings" → "/user"
                - "help", "how", "what", "learn" → "/help"
            `,
            "parameters": {
                "type": "object",
                "properties": {
                    "pageId": {
                        "type": "string",
                        "description": "The ID of the page to navigate to.",
                        "enum": ["/home", "/editor/scene/", "/editor/list", "/resources/list", "/paint/list", "/catalog/list", "/scheduler/editor", "/events/list", "/stations", "/fasterq/list", "/statistics", "/download", "/shopping/products", "/shopping/list", "/shopping/checkout", "/orders", "/user", "/help"]
                    },
                    "propertyName": {
                        "type": "string",
                        "description": "The property name of the navigation. '/editor/scene/' → 'sceneId', '/help' → 'helpName'",
                        "enum": [ "sceneId", "helpName" ]
                    },
                    "propertyValue": {
                        "type": "string",
                        "description": `
                            if pageId is '/help' get the helpName by search in the result of the function getHelpInfo().' ,
                            if pageId is '/editor/scene/' get sceneId by search in the result of the function getSceneList().`
                    }
                },
                "required": ["pageId"]
            }
        }
    },


    {
        "type": "function",
        "function": {
            "name": "getComponentsDefinition",
            "description": "get information on how to add or update component. get the playerId from this function",
        }
    },

    {
        "type": "function",
        "function": {
            "name": "getSceneList",
            "description": "get the scene list info.",
        }
    },

    {
        "type": "function",
        "function": {
            "name": "createScene",
            "description": "Create a new scene.",
            "parameters": {
                "type": "object",
                "properties": {
                    "sceneName": {
                        "type": "string",
                        "description": "The name of the new scene."
                    },
                    "width": {
                        "type": "integer",
                        "description": "The width of the new scene in pixels. Default is 1920.",
                        "default": 1920
                    },
                    "height": {
                        "type": "integer",
                        "description": "The height of the new scene in pixels. Default is 1080.",
                        "default": 1080
                    }
                },
                "required": ["sceneName", "width", "height"]
            }
        }
    },


    {
        "type": "function",
        "function": {
            "name": "selectScenes",
            "description": "Select scenes id.",
            "parameters": {
                "type": "object",
                "properties": {
                    "sceneIds": {
                        "type": "array",
                        "items": {
                            "type": "string",
                            "description": "Scene ID."
                        },
                        "description": "A list of scenes IDs."
                    }
                },
                "required": ["sceneIds"]
            }
        }
    },

    {
        "type": "function",
        "function": {
            "name": "deleteSelectedScenes",
            "description": "Delete selected scenes.",
        }
    },

    {
        "type": "function",
        "function": {
            "name": "getSceneData",
            "description": "Get the complete scene data structure (including all components, layout, metadata, etc.) for the currently selected scene.",
            "parameters": {
                "type": "object",
                "properties": {
                },
                "required": []
            }
        }
    },



    {
        "type": "function",
        "function": {
            "name": "updateSceneData",
            "description": "Update the complete scene data structure for the currently selected scene. This replaces the entire scene data (all components, layout, metadata, etc.) with the provided data. Use getSceneData() first to get the current structure, modify it, then pass it back to this function. the Json MUST be valid!",
            "parameters": {
                "type": "object",
                "properties": {
                    "sceneData": {
                        "type": "string",
                        "description": "A valid JSON string containing the complete scene data structure. CRITICAL: You MUST strictly follow the TypeScript interfaces from getComponentsDefinition(). Every property, type, and structure MUST match the interface definitions exactly - including correct player IDs, required fields, proper nesting, and type constraints (Bool as '0'|'1', Color as decimal string, etc.). Any deviation from the interfaces will cause validation errors."
                    }
                },
                "required": ["sceneData"]
            }
        }
    },



    {
        "type": "function",
        "function": {
            "name": "selectComponent",
            "description": "Select multiple components in the scene using their unique IDs.",
            "parameters": {
                "type": "object",
                "properties": {
                    "ids": {
                        "type": "array",
                        "items": {
                            "type": "string",
                            "description": "The unique ID of a component to select."
                        },
                        "description": "A list of component IDs to select."
                    }
                },
                "required": ["ids"]
            }
        }
    },


    {
        "type": "function",
        "function": {
            "name": "createVideo",
            "description": "Generate video from prompt.",
            "parameters": {
                "type": "object",
                "properties": {
                    "prompt": {
                        "type": "string",
                        "description": "Description of the video"
                    },
                    "title": {
                        "type": "string",
                        "description": "Assistant will create title base on the video description. max length of 16"
                    }
                },
                "required": ["prompt", "title"]
            }
        }
    },


    {
        "type": "function",
        "function": {
            "name": "createImage",
            "description": "Generate an image from a prompt",
            "parameters": {
                "type": "object",
                "properties": {
                    "prompt": {
                        "type": "string",
                        "description": "Description of the image"
                    },
                    "size": {
                        "type": "string",
                        "description": "The size of the image",
                        "enum": ['256x256', '512x512', '1024x1024'],
                        "default": "1024x1024"
                    },
                    "title": {
                        "type": "string",
                        "description": "Assistant will create title base on the image description. max length of 16"
                    }
                },
                "required": ["prompt", "size", "title"]
            }
        }
    },

    {
        "type": "function",
        "function": {
            "name": "modifyImage",
            "description": "Modify selected image id by the user prompt.",
            "parameters": {
                "type": "object",
                "properties": {
                    "id": {
                        "type": "string",
                        "description": "The unique id of the component to update."
                    },
                    "resourceId": {
                        "type": "string",
                        "description": "The resource id, it is under the path 'Data[0].Resource[0].$.resource'."
                    },
                    "prompt": {
                        "type": "string",
                        "description": "Prompt to modify the image."
                    },
                    "size": {
                        "type": "string",
                        "description": "The size of the image",
                        "enum": ['256x256', '512x512', '1024x1024'],
                        "default": "1024x1024"
                    },
                    "title": {
                        "type": "string",
                        "description": "Assistant will create title base on the image description. max length of 16"
                    }

                },
                "required": ["id", "resourceId", "prompt", "size", "title"]
            }
        }
    },


    {
        "type": "function",
        "function": {
            "name": "sceneCommand",
            "description": "Call scene commands only when pageId: '/editor/scene/'.",
            "parameters": {
                "type": "object",
                "properties": {
                    "command": {
                        "type": "string",
                        "description": "The scene commands.",
                        "enum": [ "SAVE", "PREVIEW", "REGISTER", "COPY", "PASTE", "UNDO", "REDO", "DELETE" ]
                    }
                },
                "required": ["command"]
            }
        }
    },

    {
        "type": "function",
        "function": {
            "name": "getResourcesInScene",
            "description": "get the resources info by resource id, that exist in the selected scene.",
            "parameters": {
                "type": "object",
                "properties": {
                    "resourceIds": {
                        "type": "array",
                        "items": {
                            "type": "string",
                            "description": "resource Id."
                        },
                        "description": "A list of resource IDs in the scene."
                    }
                },
                "required": ["resourceIds"]
            }
        }
    },

    {
        "type": "function",
        "function": {
            "name": "setAsBackground",
            "description": "set the selected Image as a background.",
        }
    },

    {
        "type": "function",
        "function": {
            "name": "removeBackground",
            "description": "remove the background image from the scene.",
        }
    },

    {
        "type": "function",
        "function": {
            "name": "layerCommand",
            "description": "push the selected item layer order.",
            "parameters": {
                "type": "object",
                "properties": {
                    "command": {
                        "type": "string",
                        "description": "The layer command.",
                        "enum": [ "Up", "Down", "Top", "Bottom" ]
                    }
                },
                "required": ["command"]
            }
        }
    },


    {
        "type": "function",
        "function": {
            "name": "getStations",
            "description": "get the stations list info. stations also refer as players",
        }
    },

    {
        "type": "function",
        "function": {
            "name": "getHelpInfo",
            "description": "get the help info.",
        }
    },


];
